/** Concepts — drawn directly from the author's own chapter summary in the book introduction. */

export interface ConceptEntry {
  t: string;
  b: string;
}

export interface Concept {
  ar: ConceptEntry;
  en: ConceptEntry;
}

export const CONCEPTS: Concept[] = [
  {
    ar: {
      t: "أول حضارة موحِّدة",
      b: "الردّ على الاعتقاد بأن المصريين القدماء عرفوا التوحيد قبل بعث حضرات الرسل، وإثبات ارتباط عقيدتهم بدعوة حضرات الرسل.",
    },
    en: {
      t: "The first monotheistic civilization",
      b: "A response to the claim that ancient Egyptians arrived at unity on their own, and the evidence linking their faith to the Messengers of God.",
    },
  },
  {
    ar: {
      t: "حضرات الرسل في مصر",
      b: "الشواهد على وجود حضرات الرسل: سيدنا إبراهيم و سيدنا يعقوب و سيدنا يوسف و سيدنا موسى و سيدنا هارون ﷺ على أرض مصر، واتّباع أهل مصر لهم.",
    },
    en: {
      t: "The Messengers in Egypt",
      b: "Evidence for the presence of the Prophets in Egypt — Prophet Abraham, Prophet Jacob, Prophet Joseph, Prophet Moses and Prophet Aaron — and the Egyptians who followed them.",
    },
  },
  {
    ar: {
      t: "معنى كلمة «فرعون»",
      b: "تفكيك المفهوم الشائع، والردّ على الزعم بأن ملوك مصر القدماء كانوا جميعًا طغاة.",
    },
    en: {
      t: "The meaning of ‘Pharaoh’",
      b: "Unpacking the common notion and refuting the claim that all ancient Egyptian kings were tyrants.",
    },
  },
  {
    ar: {
      t: "عمر الحضارة",
      b: "لماذا يرى المؤلف أن عمر الحضارة المصرية القديمة يبلغ خمسين ألف سنة، لا سبعة آلاف.",
    },
    en: {
      t: "The age of the civilization",
      b: "Why the author argues that ancient Egyptian civilization reaches back fifty thousand years — not seven thousand.",
    },
  },
  {
    ar: {
      t: "الصلاة والصيام والحج",
      b: "قراءة في الشواهد المصرية القديمة التي تدلّ على أداء شعائر تُماثل ما يؤدّيه المسلمون اليوم.",
    },
    en: {
      t: "Prayer, fasting and pilgrimage",
      b: "Reading the ancient Egyptian evidence for rites closely resembling those performed by Muslims today.",
    },
  },
  {
    ar: {
      t: "التحنيط — القراءة الصحيحة",
      b: "تفنيد الاعتقاد بأن التحنيط مرتبط ببعث الجسد، وتقديم قراءة مغايرة لغايته.",
    },
    en: {
      t: "Mummification — a corrected reading",
      b: "Refuting the idea that mummification was tied to bodily resurrection, and proposing a different account of its purpose.",
    },
  },
  {
    ar: {
      t: "صفات الخالق في النصوص",
      b: "مختارات من النصوص المصرية القديمة تصف الخالق عزّ وجلّ بما يوافق معتقد التوحيد.",
    },
    en: {
      t: "The Creator’s attributes in the texts",
      b: "Selections from ancient Egyptian texts describing the Creator in ways consistent with monotheism.",
    },
  },
  {
    ar: {
      t: "المعبد المصري القديم",
      b: "المعبد بوصفه بيت إيمانٍ وعبادةٍ وتوحيد، لا مجرّد بناءٍ شعائري وثنيّ كما صوَّره بعض الدارسين.",
    },
    en: {
      t: "The ancient Egyptian temple",
      b: "The temple as a house of faith, worship and unity — not merely the ‘pagan ritual space’ of earlier scholarship.",
    },
  },
  {
    ar: {
      t: "يوم الحساب في البرديات",
      b: "قراءة بردية «حو نفر» وما شابهها، وإيمان المصري القديم بالبعث والحساب والجنّة والنار.",
    },
    en: {
      t: "Judgment day in the papyri",
      b: "Reading the papyrus of Hu-Nefer and its kin — the ancient Egyptian faith in resurrection, reckoning, paradise and fire.",
    },
  },
  {
    ar: {
      t: "الخرطوش الملكي",
      b: "حقيقة المعنى الذي كان يحمله الاسم داخل الخرطوش، وما يدلّ عليه في السياق الإيمانيّ.",
    },
    en: {
      t: "The royal cartouche",
      b: "The true meaning carried by the name inside the cartouche, and its significance within a theological frame.",
    },
  },
  {
    ar: {
      t: "اللغة والعربيّة",
      b: "الصلة بين اللغة المصرية القديمة والعربية، ونماذج من كلماتٍ عربيّة فصحى وعامّيّة مكتوبة بحروفٍ مصريّة قديمة.",
    },
    en: {
      t: "Language and Arabic",
      b: "The ties between ancient Egyptian and Arabic — with examples of classical and colloquial Arabic words written in ancient Egyptian signs.",
    },
  },
  {
    ar: {
      t: "أخطاء الترجمة",
      b: "مراجعة نقدية لترجمات شائعة للغة المصرية القديمة شوّهت المعاني الأصليّة.",
    },
    en: {
      t: "Errors of translation",
      b: "A critical review of widely circulated translations that distorted the original meanings.",
    },
  },
  {
    ar: {
      t: "أصل الألعاب والرياضة",
      b: "مصر منبع كثيرٍ من الألعاب الرياضيّة والذهنيّة، وشواهد ذلك في النقوش والمقابر.",
    },
    en: {
      t: "The origins of games and sport",
      b: "Egypt as the source of many athletic and intellectual games, with evidence from reliefs and tombs.",
    },
  },
  {
    ar: {
      t: "الاكتشافات البعيدة",
      b: "إشارات إلى معرفة قدماء المصريين بأستراليا والأمريكتين والهند قبل زمن طويل من الاكتشافات الحديثة.",
    },
    en: {
      t: "The far discoveries",
      b: "Indications that ancient Egyptians knew of Australia, the Americas and India long before modern ‘discoveries’.",
    },
  },
  {
    ar: {
      t: "الحساب والفلك والطب",
      b: "لمحة عن ريادة المصريين القدماء في الرياضيّات والفلك والطب، وأثرهم على العلوم اللاحقة.",
    },
    en: {
      t: "Mathematics, astronomy, medicine",
      b: "A glance at the ancient Egyptians’ leadership in mathematics, astronomy and medicine, and their influence on later sciences.",
    },
  },
  {
    ar: {
      t: "مكارم الأخلاق",
      b: "الدعوة إلى الأخلاق في النصوص المصرية القديمة — حضارةُ عمارةٍ للقلب لا للأرضِ فقط.",
    },
    en: {
      t: "Nobility of character",
      b: "The ethical call in ancient Egyptian texts — a civilization that cultivated the heart, not only the land.",
    },
  },
];
